import React, { useState } from "react";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import Dropdown from "../ui/Dropdown";
//import { setCabinetGLBFromCabinetsSet } from "../../helpers/sqft3dArHelper";
import { setSQFTViewMode } from "../../../../actions/sqftFunctions";
import {prepareSQFTDataCore} from "../canvas/core/workspace/workspaceDataMapper";
import workspace from "../canvas/core/workspace";
import { SQFT_VIEW_MODE } from "../../constants";
import {setSQFTActiveLevel3Button} from "../../../../actions/sqftMenuFunctions";
import {setGroheFiltersSearchText} from "../../../../actions/groheFunctions";
import useChangeCabinetsColor from "../../hocs/useChangeCabinetsColor";
import {isProd} from "../../../../misc/fabricatorHardcode";
import {clearAllMenusEvents} from "../canvas/core/workspace/workspaceEvents";

const SQFTModeDropdown = (props) => {
  const { setSQFTViewMode, setSQFTActiveLevel3Button, setGroheFiltersSearchText, lookActiveFeature } = props;
  const items = [
    { label: "2d Mode", value: SQFT_VIEW_MODE.twoDMode },
    {
      label: "3d Mode",
      value: SQFT_VIEW_MODE.threeDMode,
      ...( !isProd() && {
        subItems: [
          { label: "Frameless", value: SQFT_VIEW_MODE.threeDModeFrameless },
          { label: "Framed", value: SQFT_VIEW_MODE.threeDModeFramed },
        ]
      })
    },
    {
      label: "Augmented Reality",
      value: SQFT_VIEW_MODE.augmentedReality,
      subItems: [
        { label: "Cabinet", value: SQFT_VIEW_MODE.augmentedRealityCabinet },
        { label: "Doors Only", value: SQFT_VIEW_MODE.augmentedRealityDoorsOnly },
      ]
    },
  ];
  const [activeItem, setActiveItem] = useState(items[0]);

  useChangeCabinetsColor(lookActiveFeature);

  // useEffect(() => {
  //   const selectedItem = items.find(item => item.value === SQFTViewMode) || items[0];
  //   if (!activeItem || selectedItem.value !== activeItem.value) {
  //     setActiveItem(selectedItem);
  //   }
  // }, [SQFTViewMode, items, activeItem]);

  const handleItemSelect = async (item) => {
    clearAllMenusEvents();
    setActiveItem(item);
    setSQFTViewMode(item.value);
    setSQFTActiveLevel3Button(null);
    setGroheFiltersSearchText("");

    if (item.value === SQFT_VIEW_MODE.twoDMode) {
      // Data without images
      const coreData = prepareSQFTDataCore();
      workspace.import(coreData);
    }

    //let sqftCalcData;
    // switch (item.value) {
    //   case SQFT_VIEW_MODE.threeDMode:
    //   case SQFT_VIEW_MODE.threeDModeFrameless:
    //     await setCabinetGLBFromCabinetsSet().then(r => void r);
    //     break;
    //   case SQFT_VIEW_MODE.augmentedReality:
    //   case SQFT_VIEW_MODE.augmentedRealityCabinet:
    //     await setCabinetGLBFromCabinetsSet().then(r => void r);
    //     break;
    //   case SQFT_VIEW_MODE.threeDModeDoors:
    //   case SQFT_VIEW_MODE.augmentedRealityDoorsOnly:
    //     await setCabinetGLBFromCabinetsSet(true).then(r => void r);
    //     break;
    //   case SQFT_VIEW_MODE.threeDModeFramed:
    //     await setCabinetGLBFromCabinetsSet(false, true).then(r => void r);
    //     break;
    //   case SQFT_VIEW_MODE.twoDMode:
    //     sqftCalcData = await prepareSQFTData();
    //     workspace.import(sqftCalcData);
    //     break;
    // }
  };

  const handleDropdownSelect = async (prevIsOpen) => {
    void prevIsOpen;
    setSQFTActiveLevel3Button(null);
    setGroheFiltersSearchText("");
  };

  return (
    <Dropdown
      className={"dropdown-mode ui-select"}
      items={items}
      activeItem={activeItem}
      onItemSelect={handleItemSelect}
      onDropdownSelect={handleDropdownSelect}
      isOpenInitially={false}
    />
  );
};

const mapStateToProps = (store) => ({
  windowWidth: store.serverState.windowWidth,
  SQFTViewMode: store.sqftState.SQFTViewMode,
  lookActiveFeature: store.lookState.lookActiveFeature,
});

const mapDispatchToProps = {
  setSQFTViewMode,
  setSQFTActiveLevel3Button,
  setGroheFiltersSearchText
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SQFTModeDropdown)
);
